import { ExpandableTable } from '@/shared/components/expandable-table'
import { formatRiskData } from './utils'
import { useMemo } from 'react'

export const DetailRiskTable = ({ data = {} }) => {
  const detailRiskData = useMemo(() => {
    if (!Object.keys(data).length) return []

    return formatRiskData(data)
  }, [data])

  return (

    <ExpandableTable
      data={detailRiskData}
      columns={[
        { key: 'klass', label: 'Módulo' },
        { key: 'attachment_type', label: 'Documento' },
        { key: 'compliance', label: 'Cumplimiento' },
        { key: 'weighting', label: 'Ponderación' },
        { key: 'risk', label: 'Cálculo del riesgo' }
      ]}
    />

  )
}
